import { atom } from 'recoil';

export const isNewRouteModalOpenAtom = atom<boolean>({
  key: 'isNewRouteModalOpenState',
  default: false,
});
